import { Grid } from "@material-ui/core";
import { green, orange, red } from '@material-ui/core/colors';
import { stringify } from "querystring";
import { useListContext, useResourceContext } from "react-admin";
import { useQuery } from "react-query";
import { client } from "../../dataProvider";
import { useListQueryParams } from "../../shared/hooks/useListQueryParams";
import { DescriptionOutlined, Euro } from "@material-ui/icons";
import { StatCard } from "../../components/StatCard";
import { GiWeight } from "react-icons/gi";
import ListAltIcon from '@material-ui/icons/ListAlt';
import { FaFileSignature } from "react-icons/fa6";
import { FaFileUpload } from "react-icons/fa";
import { TbPackages } from "react-icons/tb";
import { formatThousandsNumber } from "../../shared/utils";
import { AiOutlineFieldNumber } from "react-icons/ai";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa6";

export const CarrierDeliveryListHeader = () => {
  const resource = useResourceContext();
  const query = useListQueryParams();
  const url = `${resource}/statistics/?${stringify(query)}`;
  const { data: stats } = useQuery(
    [url],
    () => client(url, { method: "GET" }),
    {
      initialData: {
        value: 0, value_unique: 0, value_initial: 0, value_final: 0,
        value_estimate_totals: 0, missing_borderaux: 0, value_must: 0
      }
    }
  );
  const { total } = useListContext();
  return (
    <Grid container style={{ paddingTop: "0px", paddingBottom: "0px", position: "sticky", top: "0", zIndex: 1000, backgroundColor: "white", }}>
      <Grid item style={{ width: "12.5%" }}>
        <StatCard
          label={`${total ? formatThousandsNumber(total) : 0}`}
          icon={<AiOutlineFieldNumber />}
          subtitle="N° missioni"
        />
      </Grid>

      <Grid item style={{ width: "12.5%" }}>
        <StatCard
          label={`${stats.total_package_number ? formatThousandsNumber(stats.total_package_number) : 0}`}
          icon={<TbPackages />}
          subtitle="Colli Totali"
        />
      </Grid>

      <Grid item style={{ width: "12.5%" }}>
        <StatCard
          label={`${formatThousandsNumber(Math.round(stats.total_weight ? stats.total_weight : 0))}`}
          icon={<GiWeight />}
          subtitle="Peso Totale in kg"
        />
      </Grid>

      <Grid item style={{ width: "12.5%" }}>
        <StatCard
          label={`${formatThousandsNumber(stats.missing_borderaux)}`}
          icon={<FaClipboardList />}
          subtitle="Borderaux mancanti"
          color={red[500]}
        />
      </Grid>

      <Grid item container style={{ width: "50%" }}>

        <Grid item style={{ width: "25%" }}>
          <StatCard
            label={`${formatThousandsNumber(stats.value_must)}`}
            icon={<FaFileCircleExclamation />}
            subtitle="Missioni che devono avere una Bolla"
          />
        </Grid>

        <Grid item style={{ width: "25%" }}>
          <StatCard
            label={`${formatThousandsNumber(stats.value_unique)}`}
            icon={<DescriptionOutlined />}
            subtitle="Missioni con Bolle"
          />
        </Grid>

        <Grid item style={{ width: "25%" }}>
          <StatCard
            label={`${formatThousandsNumber(stats.value_initial)}`}
            icon={<FaFileUpload />}
            subtitle="Missioni con Bolle iniziali"
            color={orange[500]}
          />
        </Grid>

        <Grid item style={{ width: "25%" }}>
          <StatCard
            label={`${formatThousandsNumber(stats.value_final)}`}
            icon={<FaFileSignature />}
            subtitle="Missioni con Bolle Finali"
            color={green[500]}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
